import { DefaultBoardCreationState } from './schema';
import { createStore } from 'satcheljs';

export default createStore('CalendarBoardProjectStore', {
    defaultBoardCreationState: DefaultBoardCreationState.NotStarted,
});
